import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const AnalysisContext = createContext(null);

export function AnalysisProvider({ children }) {
  const { user, setUser } = useAuth();
  const [analyses, setAnalyses] = useState([]);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    try {
      const { data } = await api.get("/analyses");
      setAnalyses(data);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    if (user) refresh();
    else setAnalyses([]);
  }, [user, refresh]);

  // returns the created analysis; throws on error (caller handles)
  const analyze = async (url) => {
    const { data } = await api.post("/analyses", { url });
    setAnalyses((prev) => [data.analysis, ...prev]);
    if (data.user) setUser(data.user);
    return data.analysis;
  };

  const preview = async (url) => {
    const { data } = await api.post("/youtube/preview", { url });
    return data;
  };

  const remove = async (id) => {
    await api.delete(`/analyses/${id}`);
    setAnalyses((prev) => prev.filter((a) => a.id !== id));
  };

  return (
    <AnalysisContext.Provider value={{ analyses, loading, analyze, preview, remove, refresh }}>
      {children}
    </AnalysisContext.Provider>
  );
}

export const useAnalyses = () => useContext(AnalysisContext);
